/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NaturePlantTreeAIcon24Solid = forwardRef('NaturePlantTreeAIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 1.5c1.45 0 2.764.588 3.714 1.54a4.875 4.875 0 0 1 7.423 5.131A6.375 6.375 0 0 1 13.5 18.936V22.5a1.5 1.5 0 0 1-3 0v-3.564a6.375 6.375 0 0 1-6.57-10.82A5.25 5.25 0 0 1 9 1.5ZM11 18h2v-4.607l3.997-1.999a1 1 0 1 0-.894-1.788L13 11.157V8a1 1 0 1 0-2 0v5.07l-3.123-1.474a1 1 0 1 0-.854 1.808L11 15.282V18Z" })));
});
